import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  kitchenThingsData: [],
  kitchenThingsLoader: true,
  kitchenThingsError: "",
};

// `location` must be the project's location string ("KKT" / "BLR" / etc),
// not a react-router location object — passing the wrong thing here throws
// on `.toUpperCase()` and gets silently swallowed by the thunk's catch block.
const getEndpoint = (roomName, ) => {
  const loc = localStorage.getItem('userLocation');
   const prefix = loc === 'kkt' ? 'kkt' : '';
  // const prefix = localStorage.getItem('userLocation');
  const db = localStorage.getItem('projectDatabase') || '(default)'; // fallback for safety
  // return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
  return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}/${db}`;
};

export const fetchKitchenThingsList = createAsyncThunk(
  'fetchkitchenThings',
  async ({  } = {}, { rejectWithValue }) => {
    try {
      const url = getEndpoint('Kitchen');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch kitchen data');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const kitchenThingsReducer = createSlice({
  name: 'kitchenThings',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchKitchenThingsList.fulfilled]: (state, action) => {
      state.kitchenThingsData = action.payload;
      state.kitchenThingsLoader = false;
      state.kitchenThingsError = "";
    },
    [fetchKitchenThingsList.pending]: (state) => {
      state.kitchenThingsLoader = true;
      state.kitchenThingsError = "";
    },
    [fetchKitchenThingsList.rejected]: (state, action) => {
      state.kitchenThingsLoader = false;
      state.kitchenThingsError = action.payload ?? "refresh the page";
    },
  },
});

export default kitchenThingsReducer.reducer;